// Chakra imports
import {
	Text,
	useColorModeValue,
	useDisclosure,
	 Box ,
	 SimpleGrid
} from '@chakra-ui/react';


// Custom components
import IconBox from "components/icons/IconBox";
import CardApplication from "components/card/CardApplication";

// Assets
import { WebTrackingLogo, TrackingBlLogo } from 'components/icons/Icons';


import { PATH_PRIVADO, PATH_WEB_TRACKING, PATH_TRACKING_BL } from 'const/CommonConst'

export default function WebTrackingCard(props: { [x: string]: any }) {
	const { ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue("brand.400", "white");
	const brandColor = useColorModeValue("brand.500", "white");
	const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
	return (
		<Box pt='20px'>
		<Text color={textColor} fontSize='2xl' ms='24px' fontWeight='700' mb='20px'>
                Servicios Web Tracking
              </Text>
			  <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap='20px'>
						<CardApplication
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <WebTrackingLogo w='32px' h='32px' color={brandColor} />
              }
            />
          }
          name='Web Tracking' navTo={`${PATH_PRIVADO}${PATH_WEB_TRACKING}`}
        />
		
						<CardApplication
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <TrackingBlLogo w='32px' h='32px' color={brandColor} />
              }
            />
          }
          name='Tracking B/L' navTo={`${PATH_PRIVADO}${PATH_TRACKING_BL}`}
        />	</SimpleGrid></Box>
	);
}
